import React from "react";
import { Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";
import StatusBadge from "../shared/StatusBadge";
import { EscalationTrackerData } from "../../types";

interface EscalationTrackerCardProps {
  data: EscalationTrackerData;
  isStaticDisabled?: boolean;
}

const EscalationTrackerCard: React.FC<EscalationTrackerCardProps> = ({
  data,
  isStaticDisabled = false,
}) => {
  return (
    <div
      className={`escalation-tracker-card${
        isStaticDisabled ? " escalation-tracker-card--static-disabled" : ""
      }`}
    >
      <div className="escalation-tracker-card__body">
        <div className="escalation-tracker-card__header">
          <h3 className="escalation-tracker-card__title">Escalation Tracker</h3>
          <button type="button" className="escalation-tracker-card__open-link">
            {data.openTicketsLink}
            <Iconography icon="chevronRight" size={IconographySizes.Small} />
          </button>
        </div>

        <div className="escalation-tracker-card__summary">
          {data.summary.map((item) => (
            <div key={item.label} className="escalation-tracker-card__summary-box">
              <span className="escalation-tracker-card__summary-value">{item.value}</span>
              <span className="escalation-tracker-card__summary-label">{item.label}</span>
            </div>
          ))}
        </div>

        <div className="escalation-tracker-card__list">
          {data.tickets.length > 0 ? (
            data.tickets.map((ticket) => (
              <div key={ticket.id} className="escalation-tracker-card__row">
                <span
                  className={`escalation-tracker-card__priority escalation-tracker-card__priority--${ticket.priority.toLowerCase()}`}
                >
                  {ticket.priority}
                </span>
                <div className="escalation-tracker-card__content">
                  <span className="escalation-tracker-card__ticket-title">{ticket.title}</span>
                  <p className="escalation-tracker-card__meta">
                    <span className="escalation-tracker-card__meta-id">{ticket.ticketId}</span>
                    <span className="escalation-tracker-card__meta-sep" aria-hidden>
                      ·
                    </span>
                    <span>{ticket.owner}</span>
                    <span className="escalation-tracker-card__meta-sep" aria-hidden>
                      ·
                    </span>
                    <span>{ticket.date}</span>
                  </p>
                </div>
                <StatusBadge
                  label={ticket.status === "open" ? "Open" : "Resolved"}
                  variant={ticket.status}
                />
              </div>
            ))
          ) : (
            <div className="escalation-tracker-card__empty">No escalations to display</div>
          )}
        </div>
      </div>

      <button type="button" className="escalation-tracker-card__footer">
        <Iconography icon="arrowUpRightFromSquare" size={IconographySizes.Small} />
        {data.footerLinkLabel}
      </button>
    </div>
  );
};

export default EscalationTrackerCard;
